var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.doctor && _vm.doctor.isCertified && _vm.doctor.onboardingStep < 5
    ? _c("div", { staticClass: "onboarding-wrapper" }, [
        _c("div", { staticClass: "onboarding" }, [
          _c("div", { staticClass: "bubble" }, [
            _vm.doctor.onboardingStep == 0
              ? _c(
                  "div",
                  { staticClass: "bubble-text" },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("step_0_text", { name: _vm.doctor.lastName })
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("router-link", {
                      staticClass: "button is-primary mt-5",
                      attrs: { to: { name: "doctor.availabilities" } },
                      domProps: {
                        textContent: _vm._s(_vm.$t("step_0_button"))
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.setOnboardingStep(
                            _vm.doctor.onboardingStep + 1
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.doctor.onboardingStep == 1
              ? _c("div", { staticClass: "bubble-text" }, [
                  _vm.$route.name == "doctor.availabilities"
                    ? _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_1_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.dashboard" } },
                            domProps: {
                              textContent: _vm._s(_vm.$t("step_1_button"))
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.setOnboardingStep(
                                  _vm.doctor.onboardingStep + 1
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_1_helper_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.availabilities" } },
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("step_1_helper_button")
                              )
                            }
                          })
                        ],
                        1
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.doctor.onboardingStep == 2
              ? _c("div", { staticClass: "bubble-text" }, [
                  _vm.$route.name == "doctor.dashboard"
                    ? _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_2_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.emergencies" } },
                            domProps: {
                              textContent: _vm._s(_vm.$t("step_2_button"))
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.setOnboardingStep(
                                  _vm.doctor.onboardingStep + 1
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_2_helper_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.dashboard" } },
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("step_2_helper_button")
                              )
                            }
                          })
                        ],
                        1
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.doctor.onboardingStep == 3
              ? _c("div", { staticClass: "bubble-text" }, [
                  _vm.$route.name == "doctor.emergencies"
                    ? _c("div", [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.$t("step_3_text")) }
                        }),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "button is-primary mt-5",
                          domProps: {
                            textContent: _vm._s(_vm.$t("step_3_button"))
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setOnboardingStep(
                                _vm.doctor.onboardingStep + 1
                              )
                            }
                          }
                        })
                      ])
                    : _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_3_helper_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.emergencies" } },
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("step_3_helper_button")
                              )
                            }
                          })
                        ],
                        1
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.doctor.onboardingStep == 4
              ? _c("div", { staticClass: "bubble-text" }, [
                  _c("div", [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.$t("step_4_text")) }
                    }),
                    _vm._v(" "),
                    _c("button", {
                      staticClass: "button is-primary mt-5",
                      domProps: {
                        textContent: _vm._s(_vm.$t("step_4_button"))
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.setOnboardingStep(
                            _vm.doctor.onboardingStep + 1
                          )
                        }
                      }
                    })
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: "/static/img/mascot/z.png",
              alt: "Tooddoc Mascot",
              width: "90px"
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b23788aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b23788aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/Onboarding.vue
// module id = 626
// module chunks = 1